





























import Vue from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import WorldMapVue from 'world-map-vue'
import { formatNumber, formatPrice } from '~/helpers/CurrencyHelper'
import { RiskData } from '~/types/RiskData'

export default Vue.extend({
	name: 'GeographicExposure',
	components: { WorldMapVue },
	props: {
		riskData: {
			type: Array as () => RiskData,
			default: [],
		},
	},
	data() {
		return {
			countryGrouped: {} as { [countryCode: string]: number },
			countryMapData: {} as { [countryCode: string]: string },
			chartData: null as any,
			hoveredCountryCode: null as string|null,
			ready: false,
		}
	},
	mounted() {
		const sum = this.riskData.reduce((prev, share) => prev + share.value, 0)

		this.riskData.forEach((share) => {
			this.countryGrouped[share.countryCode] = (this.countryGrouped[share.countryCode] || 0) + share.value
			const alpha = Math.round((this.countryGrouped[share.countryCode] / sum) * 10) / 10
			this.countryMapData[share.countryCode] = `rgba(0, 163, 241, ${alpha})`
		})

		this.ready = true
	},
	methods: {
		formatNumber,
		formatPrice,
		onMouseEnterMapCountry(e: string) {
			this.hoveredCountryCode = e
		},
		onMouseLeaveMapCountry(e: string) {
			this.hoveredCountryCode = e
		},
	},
})
